import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { useSettings } from "@/components/Layout";
import { ArrowRight } from "lucide-react";

const VALUES = [
  ["Understanding first", "Every engagement starts with listening. We confirm what you actually need before suggesting a service — never the other way around."],
  ["Clear communication", "You always know the next step, what is needed from you, and what charges apply. No jargon, no surprises."],
  ["Coordinated assistance", "Applications, filings and follow-ups are coordinated by our team so you can stay focused on your business."],
];

export default function About() {
  const settings = useSettings();
  return (
    <div data-testid="about-page">
      <SEO title="About Us | Mynavodayans Online Services Private Limited"
           description="Meet Mynavodayans: based in Satna and serving businesses across India with registration, licensing, compliance, websites and app development."
           canonicalPath="/about" pageType="AboutPage" />
      <section className="bg-[#0a192f] py-16 text-white">
        <div className="container-x">
          <p className="eyebrow-label !text-[#f5c542]">About us</p>
          <h1 className="mt-3 max-w-3xl font-heading text-3xl font-extrabold sm:text-4xl lg:text-5xl" data-testid="about-headline">
            {settings.company_name}
          </h1>
          <p className="mt-3 font-heading text-lg text-[#f5c542]">{settings.tagline}</p>
        </div>
      </section>
      <section className="container-x grid gap-12 py-16 lg:grid-cols-[1.4fr_1fr]">
        <div>
          <p className="leading-relaxed text-slate-700">
            {settings.about_short} Based in Satna, Madhya Pradesh, we serve businesses across India. Share your location and requirement so we can confirm the scope and applicable steps.
          </p>
          <p className="mt-4 leading-relaxed text-slate-700">
            Our work covers four broad areas: business formation and registration, licensing and compliance assistance, tax and employee compliance, and digital services — custom websites and mobile applications. Whether you are starting a proprietorship in Satna, applying for FSSAI licensing in Indore, or building a website for a growing company, our team coordinates the process end to end.
          </p>
          <p className="mt-4 leading-relaxed text-slate-700">
            Mynavodayans is a private service provider. We are not a government body, and licences, registrations and approvals are issued only by the relevant authorities. Our role is to make the process understandable, organised and trackable for you.
          </p>
          <p className="mt-4 leading-relaxed text-slate-700">
            <Link to="/service-areas" className="font-semibold text-[#b07f0a] underline underline-offset-4">Explore our service areas across India</Link> and discuss the requirements for your city and state with our team.
          </p>
          <h2 className="mt-10 font-heading text-2xl font-extrabold text-[#0a192f]">How We Work</h2>
          <div className="mt-6 grid gap-4 sm:grid-cols-3">
            {VALUES.map(([t, d]) => (
              <div key={t} className="rounded-2xl border border-slate-200 bg-white p-5">
                <h3 className="font-heading text-sm font-bold text-[#0a192f]">{t}</h3>
                <p className="mt-2 text-xs leading-relaxed text-slate-600">{d}</p>
              </div>
            ))}
          </div>
        </div>
        <aside className="h-fit rounded-2xl bg-[#0a192f] p-8 text-white">
          <h2 className="font-heading text-xl font-bold text-[#f5c542]">Start a Conversation</h2>
          <p className="mt-3 text-sm text-white/70">Tell us what you are planning — we will explain your options and the next steps.</p>
          <a href={settings.phone_link} className="mt-5 block font-heading text-2xl font-extrabold text-white" data-testid="about-phone">{settings.phone_display}</a>
          <p className="mt-1 text-xs text-white/50">Call & WhatsApp</p>
          <Link to="/contact" className="btn-gold mt-6 w-full" data-testid="about-quote-btn">Request a Quote <ArrowRight size={16} /></Link>
          <Link to="/services" className="mt-3 block text-center text-sm font-semibold text-white/70 hover:text-white">Browse all services →</Link>
        </aside>
      </section>
    </div>
  );
}
